import { Component, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { getDomainBaseUrl } from '@ugc-utils/domains';
import { FontType } from '@ugc-utils/utils';
import { LinedCheck, LinedStar, LinedRewards } from '../../../../icons';

@Component({
  tag: 'ugc-answer-labels',
  styleUrl: 'ugc-answer-labels.scss',
  shadow: false,
})
export class UgcAnswerLabels {
  @Prop() fontType: FontType = FontType.large;
  @Prop() isBest: boolean = false;
  @Prop() hasRewarded: boolean = false;
  @Prop() verifiedPurchase: boolean = false;

  render() {
    const {
      qnaStaticLanguage: {
        IDS_UGC_INCENTIVE_SWITCH,
        IDS_UGC_QNA_REWARDED_ANSWER_READ_MORE = '',
        IDS_UGC_QNA_VERIFIED_PURCHASE = '',
        IDS_UGC_QNA_BEST_ANSWER = '',
        IDS_UGC_QNA_REWARDED_ANSWER = '',
        IDS_LNK_CLOSE = '',
      },
    } = state;

    const isEnableIncentive = IDS_UGC_INCENTIVE_SWITCH
      ? JSON.parse(IDS_UGC_INCENTIVE_SWITCH || '{}').EnableIncentive
      : false;
    const text = IDS_UGC_QNA_REWARDED_ANSWER_READ_MORE.replace(
      '{0}',
      `${getDomainBaseUrl('secure')}/rewards/info/rewards-program`
    );

    const isShowSign = this.isBest || this.verifiedPurchase || (isEnableIncentive && this.hasRewarded);

    if (!isShowSign) return null;

    const isLargeType = this.fontType === FontType.large;
    const fontType = isLargeType ? 'fs-14' : 'ft-12';
    const space = isLargeType ? '' : 'mb-4';
    return (
      <div class="flex-row-start-center flex-wrap ugc-answer-lables-wrap">
        {this.verifiedPurchase && (
          <div class={`sign-wrap flex-row-start-center gap-4 ${space}`}>
            <LinedCheck width="16" height="16" />
            <span class={`${fontType} c-666 `}>{IDS_UGC_QNA_VERIFIED_PURCHASE}</span>
          </div>
        )}
        {this.isBest && (
          <div class={`sign-wrap flex-row-start-center ${space} gap-4 ft-12 color-gray-600`}>
            <LinedStar fill={'#666'} />
            <span class={`${fontType} c-666 `}>{IDS_UGC_QNA_BEST_ANSWER}</span>
          </div>
        )}
        {isEnableIncentive && this.hasRewarded && (
          <div class={`sign-wrap flex-row-start-center gap-4 ${space}`} data-testid="pdp-qna-rewarded-answer">
            <LinedRewards fill={'#666'} />
            <span class={`${fontType} c-666 `}>{IDS_UGC_QNA_REWARDED_ANSWER}</span>
            <ugc-info-tooltip
              content={text}
              closeText={IDS_LNK_CLOSE}
              tooltipName="rewarded-answer"
              interactive={true}
            />
          </div>
        )}
      </div>
    );
  }
}
